import React from 'react';
import { useHistory } from 'react-router';
import { StyledPaperContainer, StyledSectionTitle } from '../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import { MasterMedicine as IMasterMedicine } from '../../../../apis/master-medicines/types';
import { ColumnWithGap } from '../../../PlusWebsiteEditor/sections/HeroBlock/HeroBlock.styled';
import { VirtualMedicine } from '../../../../apis/virtual-medicines/types';
import { HealtheraButton } from '../../../../healtheraComponents';
import ClickableVirtualMedicine from './ClickableVirtualMedicine';

interface Props {
  masterMedicine: IMasterMedicine;
  medicines: VirtualMedicine[];
}

const VirtualMedicinesList = ({ masterMedicine, medicines }: Props) => {
  const history = useHistory();

  const navigate = (path: string) => {
    history.push(path, {
      goBackLinks: [`/clinics/master-medicines/${masterMedicine._id}`]
    });
  };

  const handleAddMedicine = () => {
    if (masterMedicine) {
      navigate(`/clinics/master-medicines/${masterMedicine._id}/virtual-medicines/create`);
    }
  };

  const handleClickMedicine = (medicineId: string) => {
    if (masterMedicine) {
      navigate(`/clinics/master-medicines/${masterMedicine._id}/virtual-medicines/${medicineId}`);
    }
  };

  return (
    <StyledPaperContainer>
      <ColumnWithGap>
        <StyledSectionTitle>Virtual Medicines</StyledSectionTitle>
        {medicines?.map(medicine => (
          <ClickableVirtualMedicine
            key={medicine._id}
            masterMedicine={masterMedicine}
            medicine={medicine}
            onClick={() => handleClickMedicine(medicine._id)}
          />
        ))}
        <HealtheraButton onClick={handleAddMedicine}>Add Medicine</HealtheraButton>
      </ColumnWithGap>
    </StyledPaperContainer>
  );
};
export default VirtualMedicinesList;
